import React from 'react';

export default function ContactPage() {
  return (
    <div>
      <h2>Contact</h2>
      <p>If you have questions or feedback, email: <a href= "mailto:pkmndraft@gmail.com">pkmndraft@gmail.com</a></p>
    </div>
  );
}
